<template>
  <section
    class="cell padding-bottom-1"
  >
    <article class="pega-announcement-container">
      <div class="pega-announcement-content">
        <ul class="pega-announcement-content-ul">
          <li
            v-for="(announcement, index) in announcements"
            :key="index"
            :data-test="`announcement-modal-title-li-${index}`"
            class="pega-announcement-content-li"
          >
            <a
              :data-test="`announcement-modal-title-${index}`"
              @click="openAnnouncementModal(index)"
            >{{ announcement.title }}</a>{{ announcement.createDate | formatDate }}
          </li>
        </ul>
      </div>
    </article>
    <!-- お知らせモーダル -->
    <div
      id="announcement-modal"
      class="reveal boss-modal-container pega-modal-position pega-announcement-modal-layout"
      data-reveal
    >
      <h1
        class="boss-page-title boss-page-title-layout-title font-bold padding-right-2"
        data-test="modal-title"
      >
        {{ announcements[openAnnouncementModalIndex].title }}
      </h1>
      <div
        class="pega-announcement-modal-body"
        data-test="modal-body"
        v-html="renderBody"
      />
      <div
        v-if="announcements[openAnnouncementModalIndex].files.length"
        class="margin-top-1"
        data-test="announcement-files"
      >
        <a
          v-for="(file, index) in announcements[openAnnouncementModalIndex].files"
          :key="index"
          class="display-block"
          :data-test="`modal-file-${index}`"
          @click="download(file.id)"
        >
          {{ file.name }}
        </a>
      </div>
      <button
        class="close-button boss-close-button boss-icon-cross"
        data-test="modal-close"
        data-close
        aria-label="Close modal"
        type="button"
        @click="closeReveal()"
      />
    </div>
    <!-- お知らせモーダル -->
  </section>
</template>

<script>
import util from '@/lib/util'
import Foundation from 'foundation-sites'
import jQuery from 'jquery'
import { createDate } from '@/lib/dateUtils'
import { downloadUrl } from '@/lib/download'

export default {
  filters: {
    formatDate (val) {
      return createDate(val).format('(YYYY/MM/DD)')
    }
  },
  props: {
    announcements: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      openAnnouncementModalIndex: 0
    }
  },
  computed: {
    renderBody () {
      return util.replaceAddressAndUrlLink(this.announcements[this.openAnnouncementModalIndex].body)
    }
  },
  methods: {
    openAnnouncementModal (index) {
      if (!this.modal) {
        this.modal = new Foundation.Reveal(jQuery('#announcement-modal'))
      }
      this.$set(this, 'openAnnouncementModalIndex', index)
      this.modal.open()
    },
    closeReveal () {
      this.modal.close()
    },
    download (fileId) {
      this.$http.secured.get(`/company/announcements/${this.announcements[this.openAnnouncementModalIndex].id}/files/${fileId}/url`).then((response) => {
        downloadUrl(response.data)
      })
    }
  }
}
</script>
